import type { TypePolicies } from '../../../utils';

export const typePolicies: TypePolicies = {
  MetadataFilter: {
    merge: true,
  },
};
